import React, { useState, useEffect } from 'react';
import { Cascader } from 'antd';
import apis from '@/apis';

function SelectorHrDepart(props: any) {
  let { value, onChange, ..._props } = props;
  // value = value && value.length > 0 && value[value.length - 1];
  const [treeData, setTreeData] = useState([]);

  useEffect(() => {
    let mounted = true;
    // 父组织code  注意，京东集团根级编码为00000000
    apis.queryOrganization('00000000').then((res) => {
      if (!mounted) return;
      let dataFormBackEnd = res.data.organizationTree.map((item: any) => transformResult(item, '/00000000', ''));
      // 京东零售的数据放第一个 "00013807"
      const linshou = dataFormBackEnd.find((ele: any) => ele.value === '00013807');
      dataFormBackEnd = dataFormBackEnd.filter((ele: any) => ele.value !== '00013807');
      dataFormBackEnd.unshift(linshou);
      setTreeData(dataFormBackEnd);
    });

    return () => {
      mounted = false;
    };
  }, []);

  // 加载部门树
  const onLoadData = (treeNode: any[]) => {
    const targetNode = treeNode[treeNode.length - 1];
    if (targetNode.children && targetNode.children.length > 0) return;
    targetNode.loading = true;

    const { id, titlePath, rawId } = targetNode;
    return apis.queryOrganization(rawId).then((res) => {
      targetNode.loading = false;
      const dataFormBackEnd = res.data.organizationTree.map((item: any) => transformResult(item, id, titlePath));
      targetNode.children = dataFormBackEnd;
      setTreeData([...treeData]);
    });
  };

  function displayRender(label: string[]) {
    return <span title={label.join('/')}>{label.join('/')}</span>;
  }

  function onCheckChange(val: any[], selectedOptions: any[]) {
    const realVal: { [key: string]: any[] } = {
      value: val,
      firstDeptCodeList: [],
      secondDeptCodeList: [],
    };
    selectedOptions.map((item) => {
      const data = item[item.length - 1];
      if (data.level === 1) {
        // 体系code需要查询所有的一级部门
        if (data.children && data.children.length > 0) {
          const ids = data.children.map((ele: any) => ele.value);
          realVal.firstDeptCodeList.push(...ids);
        }
      } else if (data.level === 2) {
        realVal.firstDeptCodeList.push(data.value);
      } else {
        realVal.secondDeptCodeList.push(data.value);
      }
    });
    onChange(realVal);
  }

  return (
    <>
      <Cascader
        className="select-tree-organization"
        placeholder="请选择部门"
        changeOnSelect
        {..._props}
        multiple={true}
        expandTrigger="hover"
        onChange={onCheckChange}
        loadData={onLoadData}
        options={treeData}
        value={value?.value}
        displayRender={displayRender}
        style={{ width: '100%' }}
        dropdownRender={(data) => {
          return <div className="select-tree-drop-down">{data}</div>;
        }}
        allowClear
      />
      <div id="aaaa"></div>
    </>
  );
}

function transformResult(item: any, pId: string, titlePath: string) {
  return {
    rawId: item.organizationId,
    value: item.organizationId,
    id: `${pId}/${item.organizationId}`,
    pId: pId,
    label: item.name,
    level: item.level,
    isLeaf: !!item.isLeaf || Number(item.level) >= 3, // 只展示到二级部门
    titlePath: titlePath ? `${titlePath}-${item.name}` : item.name,
  };
}

export default SelectorHrDepart;
